import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class ProcessFlow extends ConnectBasicEntity {
condition: string;
flowName: string;
orderNumber: number | null;
processCode: string;
visionCode: string;
}

